import { Button, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { Dimensions, Image, TouchableOpacity, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import Icon from "@expo/vector-icons/MaterialIcons"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import flash from "config/flash"
import { colors } from "colors"
import Modal from "react-native-modal"
import QRCode from "react-native-qrcode-svg"
import moment from "moment-timezone"
import { useSessionExpired } from "utils/function"
import { useStores } from "models"
import { useColor } from "app/theme/getThemes"
import { BarcodeComponent } from "components/Barcode"

export const ForYouDetailScreen = () => {
  const navigation = useNavigation<any>()
  const route = useRoute()
  const { routeFrom, item }: any = route?.params || {}
  const { height, width } = useWindowDimensions()
  const [isTncOpen, setIsTncOpen] = useState(false)
  const [isRedeemOpen, setIsRedeemOpen] = useState(false)
  const [data] = useState(item)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const { sessionExpired } = useSessionExpired()
  const { userStore } = useStores()
  const [point, setPoint] = useState(userStore?.totalPoint || 0)
  const [isUserUseVoucher, setIsUserUseVoucher] = useState(!!item?.use_at)
  const [countdown, setCountdown] = useState(-1)
  const [isVoucherExpired, setIsVoucherExpired] = useState(
    item?.use_at
      ? moment().tz("Asia_Kuala_Lumpur").isAfter(moment(item?.use_at)?.add("m", 15))
      : false,
  )

  // const userUseCoupon = async () => {
  //   const responseRedeemVoucher = await redeemVoucher()
  //   console.log(responseRedeemVoucher)
  // }

  // const redeemVoucher = async () => {
  //   await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `bearer ${userStore?.accessToken}`,
  //     },
  //     body: JSON.stringify({
  //       voucher_id: data?.voucher_catalog_id,
  //       member_id: userStore?.id,
  //     }),
  //   })
  //     .then(async (res) => {
  //       if (res?.ok) {
  //         const response = await res?.json()
  //         await userUserVoucher(response?.voucher)
  //       } else {
  //         onCloseModal()

  //         const errorMsg = await res?.json()

  //         if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
  //           sessionExpired()
  //         } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
  //           flash("error", translate("errors.outOfStock"))
  //         } else if (
  //           errorMsg?.message === "Error redeem voucher. Balance is not enough to redeem."
  //         ) {
  //           flash("error", translate("errors.notEnoughPoint"))
  //         } else {
  //           flash("error", translate("errors.failedToRedeemNoVoucher"))
  //         }
  //       }
  //     })
  //     .catch((e) => {
  //       flash("error", translate("errors.failedToRedeemNoVoucher"))
  //       console.error(e)
  //     })
  // }

  const redeemVoucher = async () => {
    await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        voucher_id: data?.voucher_catalog_id,
        member_id: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          onCloseModal()
          navigation.goBack()
          flash("success", translate("voucherDetailScreen.redeemSuccesfully"))
          flash("success", `You can find your voucher under "My Rewards" `)
        } else {
          onCloseModal()

          const errorMsg = await res?.json()

          if (errorMsg?.message === "Token expired" || errorMsg?.message === "Invalid token") {
            sessionExpired()
          } else if (errorMsg?.message === "Error redeem voucher. No stock is available.") {
            flash("error", translate("errors.outOfStock"))
          } else if (
            errorMsg?.message === "Error redeem voucher. Balance is not enough to redeem."
          ) {
            flash("error", translate("errors.notEnoughPoint"))
          } else {
            flash("error", translate("errors.failedToRedeemNoVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRedeemNoVoucher"))
        console.error(e)
      })
  }

  useEffect(() => {
    if (isUserUseVoucher && item?.use_at) {
      const expirationTime = moment(item?.use_at).add(15, "minutes")
      const countdownSeconds = expirationTime.diff(moment(), "seconds")
      setCountdown(countdownSeconds)
    }
  }, [isUserUseVoucher, item?.use_at])

  useEffect(() => {
    let timer

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
    } else if (countdown === 0) {
      onCloseModal()
      setIsVoucherExpired(true)
      flash("success", "voucher expired")
    }

    return () => clearInterval(timer)
  }, [countdown])

  const formatCountdown = () => {
    const minutes = Math.floor(countdown / 60)
    const seconds = countdown % 60
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  const userUserVoucher = async (voucher) => {
    await fetch(`${process.env.API_URL}/api/voucher_list/redeem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        voucher_id: voucher?.voucher_catalog_id,
        voucher_barcode: voucher?.voucher_barcode,
        redeem_by: userStore?.id,
      }),
    })
      .then(async (res) => {
        if (res?.ok) {
          setCountdown(900)
          setIsUserUseVoucher(true)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            onCloseModal()
            flash("error", translate("errors.failedToUseVoucher"))
          }
        }
      })
      .catch((e) => {
        onCloseModal()
        flash("error", translate("errors.failedToUseVoucher"))
        console.error(e)
      })
  }

  const { companyTheme } = useColor()

  const Accordion = ({ type, text }: { type: "redeem" | "tnc"; text: string }) => {
    const openAccordion = type === "redeem" ? isRedeemOpen : isTncOpen
    const setOpenAccordion = type === "redeem" ? setIsRedeemOpen : setIsTncOpen

    const regex = /<[^>]*>/gim
    const filteredText = text?.replace(regex, "")

    return (
      <View style={style.accordionContainer}>
        <TouchableOpacity
          onPress={() => {
            setOpenAccordion(!openAccordion)
          }}
          style={style.accordionTitleContainer}
        >
          <Text>
            {type === "redeem"
              ? translate("voucherDetailScreen.howToUse")
              : translate("promotionDetailScreen.tnc")}
          </Text>
          {openAccordion ? (
            <MaterialCommunityIcons name="chevron-up" size={24} color={companyTheme.first} />
          ) : (
            <MaterialCommunityIcons name="chevron-down" size={24} color={companyTheme.first} />
          )}
        </TouchableOpacity>
        {openAccordion && (
          <View>
            <View style={style.accordionContentContainer} />
            <Text>{filteredText}</Text>
          </View>
        )}
      </View>
    )
  }

  return (
    <>
      <Screen preset="scroll" contentContainerStyle={style.scrollContent}>
        <View>
          <View
            style={{
              height: width * 0.6,
              maxHeight: height * 0.4,
              backgroundColor: companyTheme.second,
            }}
          >
            <Image
              source={{
                uri: data?.voucher_image,
              }}
              style={[style.image, { height: "100%", width: "100%", resizeMode: "contain" }]}
            />
            <TouchableOpacity onPress={() => navigation.goBack()} style={style.headerLeftButton}>
              <Icon name="arrow-back" size={28} color="white" />
            </TouchableOpacity>
          </View>
          <View style={style.container}>
            <Text style={style.title}>{data?.voucher_name}</Text>

            <View style={style.calendarContainer}>
              <MaterialCommunityIcons name="calendar-month" size={28} color={companyTheme.first} />
              {!item?.voucher_barcode ? (
                <Text style={style.dateText}>
                  {moment(item?.start_date).format("DD-MMM-YYYY")} -{" "}
                  {moment(item?.end_date).format("DD-MMM-YYYY")}
                </Text>
              ) : (
                <Text style={style.dateText}>
                  Expires at : {moment(item?.voucher_expire_at).format("DD-MMM-YYYY")}
                </Text>
              )}
            </View>

            <Text style={style.description}>
              {item?.voucher_description?.replace(/<[^>]*>/gim, "")}
            </Text>

            {/* Accordian dropdown */}

            <Accordion type="redeem" text={item?.voucher_how_to_redeem} />
            <Accordion type="tnc" text={item?.voucher_tnc} />
          </View>
          {/* Sticky bottom */}
        </View>
      </Screen>
      <View
        style={[
          style.stickyBottomContainer,
          routeFrom === "history"
            ? !isVoucherExpired
              ? {}
              : {
                  backgroundColor: colors.background,
                }
            : {},
        ]}
      >
        {routeFrom === "history" ? (
          !isVoucherExpired ? (
            <Button
              onPress={() => {
                setIsModalVisible(true)
              }}
              title={translate("voucherDetailScreen.useCoupon")}
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          ) : (
            <Text style={style.usedExpiredText}>
              {item?.use_at
                ? translate("voucherDetailScreen.usedOn")
                : translate("voucherDetailScreen.expiredOn")}{" "}
              {moment(item?.use_at ? item?.use_at : item?.end_date).format("DD-MM-YYYY • hh:mm")}
            </Text>
          )
        ) : (
          <>
            {routeFrom !== "redeemVoucher" && (
              <Text style={style.dontClickText}>
                {translate("voucherDetailScreen.dontClickCoupon")}
              </Text>
            )}
            <Button
              onPress={() => {
                if (point < item?.redeem_amt && routeFrom === "redeemVoucher") {
                  flash("error", translate("errors.failedToRedeem"))
                } else {
                  setIsModalVisible(true)
                }
              }}
              title={
                routeFrom === "redeemVoucher"
                  ? translate("voucherDetailScreen.redeem")
                  : translate("voucherDetailScreen.useCoupon")
              }
              style={style.buttonContainer}
              titleStyle={style.buttonText}
            />
          </>
        )}
      </View>

      <Modal
        isVisible={isModalVisible}
        onBackdropPress={() => {
          if (isUserUseVoucher && routeFrom !== "history") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
        onBackButtonPress={() => {
          if (isUserUseVoucher && routeFrom !== "history") {
            navigation.goBack()
            flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
            onCloseModal()
          } else {
            onCloseModal()
          }
        }}
      >
        <View style={style.modalContainer}>
          {!isUserUseVoucher ? (
            <>
              <Text>
                {routeFrom === "coupon"
                  ? translate("voucherDetailScreen.areYouSureUse")
                  : translate("voucherDetailScreen.areYouSureRedeem")}
              </Text>
              <View style={style.redeemModalContainer}>
                <Button
                  onPress={() => onCloseModal()}
                  title={
                    routeFrom === "coupon"
                      ? translate("voucherDetailScreen.useLater")
                      : translate("voucherDetailScreen.redeemLater")
                  }
                  style={[style.redeemLaterButton, { borderColor: companyTheme.first }]}
                  titleStyle={{
                    color: companyTheme.first,
                  }}
                />
                <Button
                  onPress={() => {
                    // routeFrom === "coupon" ? userUseCoupon() :
                    redeemVoucher()
                  }}
                  title={
                    routeFrom === "coupon"
                      ? translate("voucherDetailScreen.use")
                      : translate("voucherDetailScreen.redeem")
                  }
                  style={style.flex}
                />
              </View>
            </>
          ) : (
            <>
              <QRCode size={150} value={`${item?.voucher_catalog_id}-${item?.voucher_barcode}`} />
              <View
                style={{
                  marginTop: 10,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BarcodeComponent
                  format="CODE128"
                  value={`${item?.voucher_catalog_id}-${item?.voucher_barcode}`}
                  width={2}
                />
              </View>
              <View style={style.dividerView}>
                <View style={style.dividerViewStyle} />
              </View>
              <Text style={style.qrText}>{translate("voucherDetailScreen.enjoyDeals")}</Text>

              <Text style={style.qrExpiredText}>
                {translate("voucherDetailScreen.expiredIn")}{" "}
                <Text style={{ color: companyTheme.first }}>{formatCountdown()}</Text>
              </Text>

              <Button
                onPress={() => {
                  if (isUserUseVoucher && routeFrom !== "history") {
                    navigation.goBack()
                    flash("success", translate("voucherDetailScreen.useVoucherSuccessfully"))
                    onCloseModal()
                  } else {
                    onCloseModal()
                  }
                }}
                style={style.mt30}
                title={translate("common.confirm")}
              />
            </>
          )}
        </View>
      </Modal>
    </>
  )
}
